import { useContext, useEffect, useState } from 'react';
import './index.less';
import { NavigationContext } from '@/App';
import { useLocation, useParams } from 'react-router-dom';
import { IconButton, SideHeader } from 'bimui';
import { ReactComponent as CloseSvg } from 'bimui/dist/c1/icons/cancel.svg'
import classNames from 'classnames';
import { findMaterialMark } from '@/declare/api/system-lib/material';
import { message } from 'antd';
import { MaterialMark } from '@/declare/interface/project/material';


/**
 * 材料详情页签
 * @returns 
 */
export default function MaterialMarkPage() {
    const { markId } = useParams();
    const navigateContext = useContext(NavigationContext);
    const location = useLocation();

    const [panelVisible, setPanelVisible] = useState<boolean>(true);   // 右侧面板是否打开
    const [mark, setMark] = useState<MaterialMark>(null);    // 材料

    useEffect(() => {
        generateData();
    }, [markId])

    const generateData = () => {
        findMaterialMark(markId).then(res => {
            const mark = res.data;
            setMark(mark);
            navigateContext.registTab({
                key: location.pathname,
                value: mark.mark,
            })
        }).catch(err => {
            message.error("获取材料详情失败");
        })
        navigateContext.setActiveTabKey(location.pathname)
    }

    return (
        <div className='material-mark-page'>
            <div className='mark-detail-left-list'>

            </div>
            <div className={classNames({
                'mark-detail-right-panel': true,
                'show': panelVisible
            })}>
                {panelVisible && <SideHeader>
                    <div className="header">
                        <span>{mark?.mark}</span>
                    </div>
                    <IconButton wrapClassName='close-icon' small icon={<CloseSvg />} onClick={() => setPanelVisible(false)}></IconButton>
                </SideHeader>}
            </div>
        </div>
    )
}